import { supabase } from '@/integrations/supabase/client';

// Recovery links reach the app in three shapes, and the client runs with
// detectSessionInUrl: false, so the landing page must redeem them itself:
// - `?token_hash=...&type=recovery` from the recovery email template
// - `?code=...` (PKCE) when a link was requested from this browser
// - `#access_token=...&refresh_token=...&type=recovery` from admin generateLink
//   (the vendor welcome email sent by admin-onboard-vendor)
// Callers must never fall back to an existing session: it can belong to
// someone else signed in on this browser, and updateUser would change their
// password instead. Returns null when the URL carries no link.
export const redeemRecoveryLink = async (search: URLSearchParams, hash: URLSearchParams) => {
  const tokenHash = search.get('token_hash');
  if (tokenHash && search.get('type') === 'recovery') {
    return supabase.auth.verifyOtp({ type: 'recovery', token_hash: tokenHash });
  }
  const code = search.get('code');
  if (code) return supabase.auth.exchangeCodeForSession(code);
  const accessToken = hash.get('access_token');
  const refreshToken = hash.get('refresh_token');
  if (accessToken && refreshToken && hash.get('type') === 'recovery') {
    return supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken });
  }
  return null;
};

export const hasLinkError = (search: URLSearchParams, hash: URLSearchParams) =>
  [search, hash].some((params) => params.get('error') || params.get('error_code'));

export const isMissingVerifier = (error: { name?: string; message?: string }) =>
  error.name === 'AuthPKCECodeVerifierMissingError' || /code verifier/i.test(error.message ?? '');
